import React, { useEffect, createElement } from 'react';
export const META_PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Mounts the Meta (Facebook) Pixel base code and fires a PageView event.
 * Drop this once near the top of the app.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      // Already initialized — just track the (re)render as a PageView
      window.fbq('track', 'PageView');
      return;
    }
    // Standard Meta Pixel base code
    ;
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-103">
      <img height={1} width={1} style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-104" />
    </noscript>;
}
/**
 * Fire a Meta Pixel standard or custom event.
 * Safe no-op if the pixel hasn't loaded yet.
 */
export function trackPixelEvent(event: string, data?: Record<string, unknown>, type: 'track' | 'trackCustom' = 'track') {
  if (typeof window === 'undefined' || !window.fbq) return;
  if (data) {
    window.fbq(type, event, data);
  } else {
    window.fbq(type, event);
  }
}